// src/pages/ResetPasswordRedirect.js

import background from 'assets/Resc_Office.png';
import Cookies from 'js-cookie';
import React, { useEffect } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getLogo } from 'utils/images/image.utils';
import { useDispatch } from 'react-redux';
import { setUserEmail } from 'store/slices/User/userSlice';

export default function ResetPasswordRedirect({
  setShowSmallMenu,
  setPrivacyAgreed,
  setCookiesAgreed,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setShowSmallMenu?.(false);
  }, [setShowSmallMenu]);

  const goToLogin = async () => {
    if (Cookies.get('rememberMe') === 'false') dispatch(setUserEmail(''));

    // setShowSmallMenu(true);
    //setCookiesAgreed(true);
    //setPrivacyAgreed(true);
    navigate('/');
  };

  return (
    <div>
      <Container
        fluid
        className="vh-100 overflow-y-auto"
        style={{ margin: 0, padding: 0, position: 'fixed', inset: 0 }}
      >
        <div className="row g-0 h-100 position-relative">
          {/* Left image panel */}
          <div
            className="col-12 col-md-6 d-none d-md-block p-0"
            style={{
              backgroundImage: `url(${background})`,
              backgroundSize: 'cover',
              backgroundPosition: '60% 100%',
              backgroundRepeat: 'no-repeat',
            }}
          >
            <div className="row g-0 h-100 align-items-end text-center">
              <div
                className="mb-5 w-100"
                style={{
                  WebkitTextStroke: '0.3px black',
                  color: 'var(--color-font)',
                }}
              >
                <div style={{ fontSize: 20 }}>Overwatch Fusion+ </div>
                <div style={{ fontSize: 36 }}>Powered by RescAlert Inc.</div>
              </div>
            </div>
          </div>
          <div
            className="col-12 col-md-6 d-flex flex-column align-items-center justify-content-between p-0"
            style={{ background: 'var(--color-background)', color: 'var(--color-font)' }}
          >
            {/* Logo */}
            <div className="w-100 d-flex flex-column align-items-center mt-4">
              <img
                src={getLogo(true)}
                alt="Logo"
                className="p-3"
                style={{ width: '80%', maxWidth: 420 }}
              />
            </div>

            {/* Form */}
            <div className="w-100 px-3" style={{ maxWidth: 520 }}>
              <div className="text-center mb-3">
                <h3 className="fw-semibold mb-2">Your password has been reset!</h3>
                <p className="mb-4" style={{ color: '#A0AEC0' }}>
                  Your password has been successfully reset and you can now sign in.
                </p>
                <Button
                  variant="primary"
                  className="w-100 rounded-4 mt-5 mb-3 py-3"
                  onClick={() => goToLogin()}
                >
                  Return to Sign In
                </Button>
              </div>
            </div>

            {/* Footer */}
            <footer className="w-100 py-4 text-center">
              <small
                className="d-block mb-2"
                style={{
                  color: 'var(--color-font)',
                  textShadow: '0 1px 2px rgba(0,0,0,.4)',
                }}
              >
                © 2023 – {new Date().getFullYear()}, Powered by RescAlert Inc.
              </small>
              <div className="d-flex justify-content-center flex-wrap gap-4">
                <button
                  type="button"
                  className="btn btn-link text-decoration-none px-0"
                  style={{ color: 'var(--color-font)', opacity: 0.6 }}
                  onClick={() => {}}
                >
                  Marketplace
                </button>
                <button
                  type="button"
                  className="btn btn-link text-decoration-none px-0"
                  style={{ color: 'var(--color-font)', opacity: 0.6 }}
                  onClick={() => {}}
                >
                  Blog
                </button>
                <button
                  type="button"
                  className="btn btn-link text-decoration-none px-0"
                  style={{ color: 'var(--color-font)', opacity: 0.6 }}
                  onClick={() => {}}
                >
                  License
                </button>
              </div>
            </footer>
          </div>
        </div>
      </Container>
    </div>
  );
}
